class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {

    if (document.querySelector('#fixed-action-add-to-cart .pre-loading')) {
      document.querySelector('#fixed-action-add-to-cart .pre-loading').remove();
    }
    
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    
    document.body.classList.add('fade-active');
    document.body.addEventListener('click', this.onBodyClick);

    //discount steps
    initSpecilDiscountSteps();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('fade-active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') { 
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

function initSpecilDiscountSteps() {
          // Get the discount cart total from the data attribute
          var discountContainer = document.querySelector('.discount-container');
          if (!discountContainer) return; // Exit if no discount container is found
  
          var cartTotal = parseFloat(discountContainer.getAttribute('data-discount-cart-total').replace(/[^0-9.-]+/g, '')); // Remove any non-numeric characters
  
          // Get all discount options
          var discountOptions = document.querySelectorAll('.discount-option');
  
          // Initialize variable to store the previous limit
          var previousLimit = 0;
  
          // Loop through each discount option
          discountOptions.forEach(function(option, i) {
              setTimeout(function(){
                  var limit = parseFloat(option.getAttribute('data-discount-option-limit'));
                  var currentDiv = option.querySelector('.discount-line .current');
              
                  if (currentDiv) {
                      if (cartTotal >= limit) {
                          // If cart total is greater than or equal to the current limit
                          option.classList.add('active');
                          // Calculate the percentage of the current limit relative to the previous limit
                          var percentage = 100; // Full width for the current threshold
                          currentDiv.style.width = percentage + '%';
                      } else {
                          // If cart total is less than the current limit
                          var percentage = 0;
                          if (previousLimit < cartTotal) {
                              // Calculate percentage of how much is left from the previous limit to the current limit
                              var totalRange = limit - previousLimit;
                              var currentRange = cartTotal - previousLimit;
                              percentage = (currentRange / totalRange) * 100;
                          }
                          // Cap the percentage to 100% maximum
                          percentage = Math.min(percentage, 100);
                          currentDiv.style.width = percentage + '%';
                      }
                  }
          
                  // Update the previous limit for the next iteration
                  previousLimit = limit;
              }, i * 300); // Delay each option's initialization
          });
      }
  
      // Call the function initially


customElements.define('cart-notification', CartNotification);
